import routes from '@/modules/drugIndex/drugIndex-routes';
import store from '@/modules/drugIndex/drugIndex-store';

export default {
  routes,
  store
};
